import { SquareButton } from "./SquareButton";
export default function DiscordButton() {
  return <SquareButton variant="contained" href="https://discord.gg/6TJM88xkM4" target="_blank">Discord</SquareButton>;
}
